import { saveDescriptionOfMerchandiseLineItem } from '../api/setFormData'

export const getCookie = (cname) => {
  var name = cname + "="
  var decodedCookie = decodeURIComponent(document.cookie)
  var ca = decodedCookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export const renumberLaceyActContainers = (containers) => (
  containers.map((container, index) => {
    let containerKeyInfo = container.key.split('.')
    containerKeyInfo[1] = index + 1
    container.key = containerKeyInfo.join('.')
    return container
  })
)

export const renumberPGAItems = (items) => (
  items.map((item, index) => {
    for (let type in item) {
      let itemKeyInfo = item[type].key.split('.')
      itemKeyInfo[1] = index + 1
      item[type].key = itemKeyInfo.join('.')
    }
    return item
  })
)


// Formats flat HTS with appropiate '.'
export const formatHTS = hts => {
  if (hts !== undefined) {
    let newHts = hts.replace(/[.]/g, '')
    if (newHts.length < 5) return hts
    if (newHts.length >= 5 && newHts.length <= 6) {
      newHts = insertIntoString(newHts, 4, '.')
      return newHts
    }
    if (newHts.length >= 7 && newHts.length <= 8) {
      newHts = insertIntoString(newHts, 4, '.')
      newHts = insertIntoString(newHts, 7, '.')
      return newHts
    }
    if (newHts.length >= 9) {
      newHts = insertIntoString(newHts, 4, '.')
      newHts = insertIntoString(newHts, 7, '.')
      newHts = insertIntoString(newHts, 10, '.')
      return newHts
    }
  }
}


export const hasFieldKN = (stringInput) => {
  if(stringInput == -999)return false; 
  if(stringInput == "_BLANK_")return false;
  return !!((stringInput||"")+"").trim();
}

export const allPossibleChinaExlcusionHTSTriggers =()=> {
  return ["99038867","99038866","99038869"];
}
export const chinaExlcusionHTSTriggers = (entryDate)=>{
  const JUNE_15_2024 = 1718409600000;
  if(!entryDate)return["99038867"];
  let isBetweenJune2023andDecember2021 = (entryDate<1685602800000 && entryDate>1641024000000);
  if(isBetweenJune2023andDecember2021)return["99038867","99038866"];
  if(entryDate >= JUNE_15_2024){
    return ["99038869"];
  }
  return["99038867"];
}

export const formatHTSTree = hts => {
  if (hts !== undefined) {
    let newHts = hts.replace(/[.]/g, '')
    if (newHts.length <= 3) return newHts.slice(0, 2)
    if (newHts.length <= 5 && newHts.length <= 6) {
      return newHts.slice(0, 4)
    }
    else {
      let cutHTS = newHts.slice(0, 6)
      cutHTS = insertIntoString(cutHTS, 4, '.')
      return cutHTS
    }
  }
}

export const insertIntoString = (str, index, value) => {
  return str.substr(0, index) + value + str.substr(index)
}

export const  changeCountryOfOrigin = (newCountryOfOrigin,props) =>{
  let {countryOfOrigin,lineItemIndex,invoiceItemIndex,
    updateMerchLineItemFeild,
    saveDescriptionOfMerchandiseLine,
    setHSDTL,
    handleLineItemContextSwitch,
    htsBasedAvailableCodes,
    updateTradeAgreementListOnCountryChange,
    merchandiseItem,
    itDate,
    entryDate,
    invoiceId,
    merchandiseId
  } = props;
  updateMerchLineItemFeild(
    lineItemIndex,invoiceItemIndex,
    'countryOfOrigin',
    newCountryOfOrigin
  )
  const myDuty = props?.merchandiseItem?.merchandiseDuties?.find(aaa => aaa.isCommodityDuty == 1)
    || props?.merchandiseDuties?.find(aaa => aaa.isCommodityDuty == 1);
  let merchandiseDutyEv = [
    {
      "enteredValue": myDuty.enteredValue,
      "merchandiseDutyId": myDuty.merchandiseDutyId,
      "isCommodityDuty": myDuty.isCommodityDuty
    }]

  saveDescriptionOfMerchandiseLineItem(merchandiseId, invoiceId , 'countryOfOrigin', newCountryOfOrigin, myDuty?{addedParametersx:{merchandiseDuties:merchandiseDutyEv}}:{}).then((resp)=>{
    handleLineItemContextSwitch(lineItemIndex , invoiceItemIndex)

    if(countryOfOrigin!==newCountryOfOrigin){

      if(merchandiseItem && merchandiseItem.merchandiseDuties && merchandiseItem.merchandiseDuties.length){
        let hts = merchandiseItem.merchandiseDuties[0].htsus;
          setHSDTL(
            itDate,
            props.EntryTypeInfo,
            hts,invoiceItemIndex,
            lineItemIndex,
            0,
            1,
            false,
            props.invoiceId,
            props.merchandiseId,
            newCountryOfOrigin,
            props.merchandiseItem
          )
      }
    }
    
    if(htsBasedAvailableCodes){
      updateTradeAgreementListOnCountryChange(lineItemIndex,invoiceItemIndex, newCountryOfOrigin)
    }
  })
  
}

export const resetDutyItemFieldsInNonCommodity= (updateMerchDutyItemObject,lineItemIndex,invoiceItemIndex,myindexofduty,saveMerchDutyItem,updateMerchDutyItemFeild) =>  {
  updateMerchDutyItemObject(
    lineItemIndex,invoiceItemIndex,
    myindexofduty,
    'manifestQuantity',
    'units',
    "_BLANK_"
  )
  updateMerchDutyItemObject(
    lineItemIndex,invoiceItemIndex,
    myindexofduty,
    'additionalQuantity',
    'units',
    "_BLANK_"
  )
  updateMerchDutyItemObject(
    lineItemIndex,invoiceItemIndex,
    myindexofduty,
    'manifestQuantity',
    'quantity',
    parseFloat(0.00).toFixed(2)
  )
  saveMerchDutyItem(lineItemIndex,invoiceItemIndex, myindexofduty, 'manifestQuantity')
  updateMerchDutyItemObject(
    lineItemIndex,invoiceItemIndex,
    myindexofduty,
    'additionalQuantity',
    'quantity',
    parseFloat(0.00).toFixed(2)
  )
  saveMerchDutyItem(lineItemIndex,invoiceItemIndex, myindexofduty, 'additionalQuantity')
  updateMerchDutyItemFeild(invoiceItemIndex,
    lineItemIndex,
    myindexofduty,
    'enteredValue',
    parseFloat(0.00).toFixed(2)
  )
  saveMerchDutyItem(lineItemIndex,invoiceItemIndex, myindexofduty, 'enteredValue')
  updateMerchDutyItemFeild(invoiceItemIndex,
    lineItemIndex,
    myindexofduty,
    'invoiceCurrencyValue',
    parseFloat(0.00).toFixed(2)
  )
  saveMerchDutyItem(lineItemIndex,invoiceItemIndex, myindexofduty, 'invoiceCurrencyValue')

}

export const fetchSelectedReasonCodes = (reasons=[], key) => {
  let codes = [];
  reasons.map((item)=>{
    if(item.key === key){
      item.reasonCodes && item.reasonCodes.map((_item)=>{
        codes.push(_item.code);
      })
    }
  })
  return codes;
}

export const totalHeaderReasonSelected = (pscData) => {
  let totalHeaderReasonSelected =  pscData.headerCodes ? pscData.headerCodes.map((item)=>{
    return item.reasonCodes ? item.reasonCodes.length : 0
  }).reduce((a, b) => a + b, 0) : 0;
  return totalHeaderReasonSelected;
}

export {
  pgaLabels,
  pgaErrors
} from '../text/pga'